<script setup lang="ts">
const currentYear = new Date().getFullYear()
</script>

<template>
  <div class="footer__container">

    <div class="footer__company-info">
      <p class="footer__address util-mb-sm">
        Corp Office:SCO: 50-51, Floor 3, Sector 34-A, Chandigarh- 160022
      </p>
      <p class="footer__address util-mb-sm">
        Registered Office: 301 Chawla Complex Commercial Premises, Sector 15,
        CBD Belapur, Navi Mumbai 400614 Maharashtra
      </p>
      <p class="footer__small util-mb-sm">
        © {{ currentYear }} EquiRize. All rights reserved. | CIN: U66190MH2024PTC430982 |
        SEBI Registration Number (Stock Broker): INZ000323730 | BSE Membership
        No. 6914 - Debt Segment | NSE Membership No. 90472 - Debt Segment
      </p>
      <p class="footer__small">Compliance Officer:</p>
      <p class="footer__small">Lavanya Sharma</p>
      <p class="footer__small util-mb-sm">
        <u><a href="mailto:compliance@EquiRize.com"
            aria-label="Email Compliance: compliance@EquiRize.com">compliance@EquiRize.com</a></u>, <u><a
            href="tel:+919063459052" aria-label="Call Compliance: +91-9063459052">+91-9063459052</a></u>
      </p>
    </div>

    <div class="footer__text-block" >
      <p class="util-mb-sm" role="note" aria-label="Regulatory Risk Disclosure">
        <b>Fixed returns do not constitute guaranteed or assured returns. Investments in corporate debt securities, municipal debt securities/securitised debt instruments are subject to credit risks, market risks and default risks including delay and/or default in payment. Read all the offer related documents carefully.</b>
      </p>

      <p id="redressal-heading">Complaint Redressal via SEBI SCORES:</p>

      <ul class="footer__list" aria-labelledby="redressal-heading" style="list-style: none; padding: 0;">
        <li class="footer__small">
          (i) Register on the SCORES portal at
          <a href="https://scores.sebi.gov.in" target="_blank" rel="noopener noreferrer"
            aria-label="S C O R E S portal at s c o r e s dot s e b i dot g o v dot i n. Opens in a new tab.">
            <b>scores.sebi.gov.in</b>
          </a>
        </li>

        <li class="footer__small">
          (ii) Mandatory details: Name, <span aria-label="P A N">PAN</span>, Address, Mobile Number, Email ID
        </li>

        <li class="footer__small">
          (iii) Benefits: Transparent communication and faster resolution of grievances
        </li>
      </ul>
    </div>

    <div class="footer__text-block util-mb-sm">
      <p class="footer__small">Investor Protection Guidelines:</p>
      <ol class="tight-list">
        <li>
          Prevent Unauthorised Transactions:
          <ul>
            <li>
              Update your mobile number and email ID with your Stock Broker and
              Depository Participant.
            </li>
            <li>
              Receive transaction alerts directly from the Exchange and
              NSDL/CDSL the same day.
            </li>
          </ul>
        </li>
        <li>
          IPO Application Process:
          <ul>
            <li>
              No need to issue a cheque. Mention your bank account number and
              sign the IPO application form to authorise payment via ASBA.
            </li>
            <li>
              In case of non-allotment, funds remain in your bank account.
            </li>
          </ul>
        </li>
        <li>
          KYC Compliance:
          <ul>
            <li>
              KYC is a one-time process. Once completed with a SEBI-registered
              intermediary (broker, DP, mutual fund, etc.), it is valid across
              all intermediaries.
            </li>
          </ul>
        </li>
        <li>
          Stay Vigilant:
          <ul>
            <li>
              Beware of fraudsters sending bulk messages with fake investment
              tips or promises of guaranteed returns.
            </li>
            <li>
              Do not engage in unauthorised portfolio management or collective
              investment schemes promising fixed/guaranteed returns.
            </li>
          </ul>
        </li>
      </ol>
    </div>

    <div class="footer__text-block util-my-lg">
      <p class="footer__small">
        Important Note: Fixed Deposits (FDs) and Peer to Peer (P2P) Lending are
        not exchange-traded products. EquiRize Securities solely connects
        investors/lenders with said products.
      </p>
    </div>

    <div class="footer__text-block util-mb-lg">
      <p class="footer__small"><strong>SEBI presents Samajh Se Investing Simple:</strong></p>
      <ul class="tight-list">
        <li>Understand Before You Invest</li>
        <li>Choose Regulated Investment Products</li>
        <li>Start Early, Stay Invested</li>
        <li>Beware of Investment Frauds</li>
      </ul>
    </div>

    <div class="footer__text-block util-mb-lg">
    <h3 class="util-mb-sm" id="digitalLable">
        <strong class="util-bold-text">
            Digital Accessibility
        </strong>
    </h3>

    <p class="footer__small">
        We are committed to ensuring that our digital platforms are accessible to all users,
        including persons with disabilities, in line with applicable SEBI guidelines.
    </p>

    <p id="accessibility-heading" class="util-mb-sm">
        For any accessibility-related assistance or concerns, please contact:
    </p>

    <ul class="footer__accessibility-list" aria-labelledby="accessibility-heading">
        <li class="footer__small">
            <strong>Nodal Officer – Digital Accessibility</strong>
        </li>
        <li class="footer__small">
            Name: Mohit Gupta
        </li>
        <li class="footer__small">
            Designation: Director
        </li>
        <li class="footer__small">
            Email: <a href="mailto:accessibility@equirize.com">accessibility@equirize.com</a>
        </li>
        <li class="footer__small">
            Contact: <a href="tel:+919818544346">+91 9818544346</a>
        </li>
    </ul>
</div>

    <div class="footer__text-block util-mb-lg">
      <h3 class="footer__small util-bold-text">Attention Investors:</h3>
      <ul class="tight-list">
        <li>
          Stock Brokers can accept securities as margin only through pledge in
          the depository system (w.e.f. September 1, 2020).
        </li>
        <li>
          Ensure your contact details are updated to receive OTPs directly from
          NSDL/CDSL for pledge creation.
        </li>
        <li>
          Review your holdings regularly via the Consolidated Account Statement
          issued monthly by NSDL/CDSL.
        </li>
      </ul>
    </div>

    <div class="footer__text-block footer__useful-links">
      <h3 class="footer__small util-bold-text" id="useful-links-title">Useful Links:</h3>
      <ul class="footer__useful-links-ul">
      <li>
        <u><a href="https://www.sebi.gov.in" aria-label="SEBI website. Opens in a new tab."
          target="_blank" rel="noopener noreferrer">SEBI Website</a></u>
        </li>
      <li>
        <u><a href="https://www.nsdl.co.in" aria-label="NSDL website. Opens in a new tab."
          target="_blank" rel="noopener noreferrer">NSDL Website</a></u>
      </li>
      <li>
        <u><a href="https://www.cdslindia.com" aria-label="CDSL website. Opens in a new tab."
          target="_blank" rel="noopener noreferrer">CDSL Website</a></u>
      </li>
      <li>
        <u><a href="https://www.nseindia.com" aria-label="NSE website. Opens in a new tab."
          target="_blank" rel="noopener noreferrer">NSE India Website</a></u>
      </li>
      <li>
        <u><a href="https://www.bseindia.com" aria-label="BSE website. Opens in a new tab."
          target="_blank" rel="noopener noreferrer">BSE India Website</a></u>
      </li>
      <li>
        <u><a href="https://scores.sebi.gov.in" aria-label="SCORES portal for grievances. Opens in a new tab."
          target="_blank" rel="noopener noreferrer">SEBI SCORES 2.0</a></u>
      </li>
      <li>
        <u><a href="https://smartodr.in" aria-label="SMART ODR portal for dispute resolution. Opens in a new tab."
          target="_blank" rel="noopener noreferrer">SMART ODR Portal</a></u>
      </li>
      </ul>

      <p class="footer__issued">
        Issued in the interest of investors by EquiRize Securities Private
        Limited.
      </p>
    </div>

    <!-- <div class="footer__bottom">
      <div class="footer__legal">
        <b><NuxtLink to="/terms-and-conditions">Terms & Conditions</NuxtLink></b>
        <b><NuxtLink to="/privacy-policy">Privacy Policy</NuxtLink></b>
      </div>
    </div> -->
  </div>
  <a href="https://calendly.com/neha-equirize/30min" target="_blank" rel="noopener noreferrer" class="bookCallLogo"
    aria-label="Book a call with an Equirize expert (opens in new tab)">
    <img class="bookCallLogo" src="/icons/footerCall.svg" alt="Contact us Icon" aria-hidden="true" />
    <p class="bookCallText" aria-hidden="true">Book a Call</p>
  </a>
  <a href="https://wa.me/918712498971" class="whatsapp" target="_blank" rel="noopener noreferrer"
    aria-label="Chat with us on WhatsApp (opens in new tab)">
    <img class="whatsapp" src="/icons/WhatsAppFooter.svg" alt="Whatsapp Icon" aria-hidden="true" />
    <p class="whatsappText" aria-hidden="true">Chat on WhatsApp</p>
  </a>
</template>

<style scoped>
.footer {
  padding: 28px 0 20px;
}

.footer__container {
  max-width: 100%;
  margin: 0 auto;
  padding: 0;
}

.bold-text {
  font-weight: 700;
}

.bold-link {
  font-weight: 700;
}

.footer__top {
  grid-template-columns: 1.2fr 1fr 1fr;
  gap: 24px;
  align-items: start;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
}

.footer__logo {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}

.logo__image {
  height: 24px;
}

.footer__company-name {
  font-family: var(--font-family-primary);
  font-size: 16px;
  color: var(--primaryText);
  margin: 0 0 8px 0;
}

.footer__links {
  display: contents;
}

.footer__link-group h4 {
  font-family: var(--font-family-primary);
  font-size: 17px;
  color: var(--primaryText);
  margin: 0 0 8px 0;
}

.footer__link-group ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.footer__link-group li {
  margin: 12px 0;
}

.footer__link-group a {
  font-family: var(--font-family-primary);
  font-size: 14px;
  color: var(--color-on-surface-variant);
  text-decoration: none;
}

.footer__link-group a:hover {
  color: var(--primaryText);
}

.footer__social {
  display: flex;
  gap: 8px;
  margin-top: 38px;
}

.social-icon {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.social-icon i {
  font-size: 16px;
  color: #fff;
}

.social-icon.facebook {
  background: #1877f2;
}

.social-icon.twitter {
  background: #1da1f2;
}

.social-icon.linkedin {
  background: #0077b5;
}

.social-icon.instagram {
  background: #e4405f;
}

.social-icon.youtube {
  background: #ff0000;
}

.footer__badges {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin: 36px 0 36px 0;
}

.badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 15px;
  color: var(--primaryText);
}

.badge-icon {
  width: 18px;
  height: 18px;
}

.footer__company-info {
  margin: 0 0 8px 0;
}

.footer__address {
  font-family: var(--font-family-primary);
  font-size: 14px;
  color: var(--primaryText);
}

.footer__small {
  font-family: var(--font-family-primary);
  font-size: 14px;
  color: var(--primaryText);
  margin: 0 0;
}

.footer__text-block p {
  font-family: var(--font-family-primary);
  font-size: 14px;
  color: var(--primaryText);
  line-height: 1.45;
}

.footer__text-block p a {
  color: var(--primaryText);
}

.footer__useful-links-ul {
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.footer__useful-links-ul li a {
  display: inline-block;
  min-height: 24px;
  line-height: 24px;
  padding: 2px 0;
}

.footer__accessibility-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.tight-list {
  margin: 0 0 0 18px;
  padding: 0;
}

.tight-list.bold-text>li {
  font-weight: 700;
}

.tight-list.bold-text>li::marker {
  font-weight: 700;
}

.tight-list.bold-text>li ul li {
  font-weight: 700;
}

.tight-list ul {
  margin: 0 0 0 18px;
  padding: 0;
  list-style-type: disc;
}

.tight-list li {
  font-family: var(--font-family-primary);
  font-size: 14px;
  color: var(--primaryText);
}

.util-mb-sm {
  margin-bottom: 12px !important;
}

.util-mb-lg {
  margin-bottom: 24px !important;
}

.util-my-lg {
  margin: 36px 0 36px 0;
}

.footer__bottom {
  text-align: left;
  padding-top: 10px;
  margin-top: 32px;
}

.footer__issued {
  font-family: var(--font-family-primary);
  font-size: 14px;
  color: var(--primaryText);
  margin: 0;
}

.footer__legal {
  display: flex;
  align-items: center;
  gap: 32px;
}

.footer__legal a {
  font-family: var(--font-family-primary);
  font-size: 14px;
  color: var(--primaryText);
  text-decoration: none;
}

.footer__legal a:hover {
  color: var(--primaryText);
  text-decoration: underline;
}

#digitalLable{
  font-size: 14px;
}

/* Mobile adjustments */
@media (max-width: 480px) {
  .footer__top {
    grid-template-columns: 1fr;
    gap: 16px;
    display: flex;
    flex-direction: column;
  }

  .logo__image {
    height: 20px;
  }

  .footer__company-name {
    font-size: 14px;
  }

  .footer__link-group h4 {
    font-size: 15px;
  }

  .footer__link-group a {
    font-size: 12px;
  }

  .footer__address,
  .footer__small,
  .footer__text-block p,
  .tight-list li,
  .footer__issued,
  .footer__legal a {
    font-size: 12px;
  }

  .badge {
    font-size: 13px;
  }

  .badge-icon {
    width: 16px;
    height: 16px;
  }

  .footer__badges {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .footer__link-group li {
    margin: 4px 0;
  }
}

/* Mobile-first Floating Buttons */
.bookCallLogo {
  z-index: 999;
  position: fixed;
  bottom: 70px;
  right: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
}

.bookCallLogo img.bookCallLogo {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  /* box-shadow: 0 2px 8px rgba(0,0,0,0.2); */
  transition: transform 0.2s;
}

.bookCallLogo img.bookCallLogo:hover {
  transform: scale(1.08);
}

.bookCallText {
  display: none;
  margin-top: 4px;
  padding: 4px 10px;
  background: #fff;
  color: #232323;
  font-size: 11px;
  font-weight: 600;
  border-radius: 6px;
  /* box-shadow: 0 2px 6px rgba(0,0,0,0.2); */
  white-space: nowrap;
  z-index: 1000;
}

.bookCallLogo:hover .bookCallText,
.bookCallLogo:focus-visible .bookCallText {
  display: block;
}

.whatsapp {
  z-index: 999;
  position: fixed;
  bottom: 12px;
  right: 12px;
  display: flex;
  align-items: center;
}


.whatsappText {
  display: none;
  margin-top: 4px;
  padding: 4px 10px;
  background: #fff;
  color: #232323;
  font-size: 11px;
  font-weight: 600;
  border-radius: 6px;
  /* box-shadow: 0 2px 6px rgba(0,0,0,0.2); */
  white-space: nowrap;
  z-index: 1000;
}

.whatsapp:hover .whatsappText,
.whatsapp:focus-visible .whatsappText {
  display: block;
}

.whatsapp img.whatsapp {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  /* box-shadow: 0 2px 8px rgba(0,0,0,0.2); */
  transition: transform 0.2s;
}

.whatsapp img.whatsapp:hover {
  transform: scale(1.08);
}


/* Desktop adjustments */
@media (min-width: 768px) {
  .bookCallLogo {
    bottom: 90px;
    right: 20px;
  }

  .bookCallLogo img.bookCallLogo {
    width: 66px;
    height: 66px;
  }

  .bookCallText {
    font-size: 13px;
    padding: 5px 12px;
  }

  .whatsapp {
    bottom: 30px;
    right: 20px;
  }

.footer__useful-links-ul a {
  display: inline-block;
  min-height: 24px;
  padding: 4px 0;
  line-height: 1.5;
}
}
</style>
